import { getConfig } from "@/config";
import { type Locale } from "@/domain";
import { getCountryFromLocale } from "@/domain/country";

import { PayPalBnplMessageClient } from "./PayPalBnplMessage.client";

export interface PayPalBnplMessageProps {
	amount?: number;
	locale: Locale;
	clientTokenEndpoint?: string;
}

export function PayPalBnplMessage({
	amount,
	locale,
	clientTokenEndpoint
}: PayPalBnplMessageProps): JSX.Element {
	let paypal: { clientTokenEndpoint?: string } | undefined;
	try {
		paypal = getConfig()?.paypal;
	} catch {
		// In browser/Storybook the endpoint arrives as a prop, not from getConfig.
	}

	const endpoint = clientTokenEndpoint ?? paypal?.clientTokenEndpoint;
	const country = getCountryFromLocale(locale);
	const currency = country === "CA" ? "CAD" : "USD";

	if (!endpoint || typeof amount !== "number" || amount <= 0) {
		return <></>;
	}

	return (
		<PayPalBnplMessageClient
			clientTokenEndpoint={endpoint}
			amount={amount}
			currency={currency}
			country={country}
		/>
	);
}
